import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../helpers/axios';
import Button from '../../../components/bootstrap/Button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '../../../components/bootstrap/Modal';
import Icon from '../../../components/icon/Icon';
import showNotification from '../../../components/extras/showNotification';
import { useAccessControl } from '../../../contexts/AccessControlContext';

const LogoutPage = () => {
  const navigate = useNavigate();
  const { clearAccessControl } = useAccessControl();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      await api.post('/api/auth/logout');
      clearAccessControl();
      navigate('/auth-pages/login', { replace: true });
    } catch (error) {
      setIsLoggingOut(false);
      showNotification('Logout Failed', 'Unable to log out. Please try again.', 'danger');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Modal
      isOpen
      setIsOpen={handleCancel}
      size='sm'
      titleId='confirm-logout-modal'
      isStaticBackdrop={false}
      isScrollable={false}
      isCentered
      initial={{ opacity: 0, scale: 0.75 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.75 }}
      transition={{ ease: 'easeOut', duration: 0.2 }}
    >
      <ModalHeader setIsOpen={handleCancel}>
        <ModalTitle id='confirm-logout-modal'>
          <Icon icon='Logout' className='me-2 text-danger' />
          Logout
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className='d-flex align-items-start'>
          <div className='flex-shrink-0 me-3'>
            <div
              className='rounded-circle d-flex align-items-center justify-content-center'
              style={{
                width: '48px',
                height: '48px',
                backgroundColor: 'rgba(220, 53, 69, 0.1)',
                border: '2px solid rgba(220, 53, 69, 0.2)',
              }}
            >
              <Icon icon='Logout' className='text-danger' size='lg' />
            </div>
          </div>
          <div className='flex-grow-1'>
            <h6 className='mb-1 text-dark'>Confirm Logout</h6>
            <p className='mb-0 text-muted'>
              Are you sure you want to log out? You will need to sign in again to access the
              dashboard.
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color='light' onClick={handleCancel} isDisable={isLoggingOut}>
          No, Cancel
        </Button>
        <Button
          color='danger'
          className='d-inline-flex align-items-center gap-2'
          onClick={handleLogout}
          isDisable={isLoggingOut}
        >
          {isLoggingOut ? (
            <>
              <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' />
              Logging out...
            </>
          ) : (
            <>
              <Icon icon='Check' />
              Yes, Logout
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LogoutPage;
